export const LOAD_DRIVER_FOR_SCHEDULING = 'LOAD_DRIVER_FOR_SCHEDULING';
export const GET_DRIVER_FOR_SCHEDULING = 'GET_DRIVER_FOR_SCHEDULING';
export const CLEAR_DRIVER_FOR_SCHEDULING = 'CLEAR_DRIVER_FOR_SCHEDULING';